import { getPage } from '@/lib/content-registry';
import { m } from '@/paraglide/messages.js';
import { SiteFooter } from '@/components/site-footer';

export function Footer() {
  return (
    <SiteFooter
      tagline={m['control.disclaimer']()}
      columns={[
        {
          title: m['control.footer.tools'](),
          links: [
            { href: '/build-planner', label: m['control.nav.planner']() },
            { href: '/puzzles', label: m['control.nav.puzzles']() },
            { href: '/abilities', label: m['control.nav.abilities']() },
            { href: '/quests', label: m['control.nav.quests']() },
          ],
        },
        {
          title: m['control.footer.guides'](),
          links: [
            {
              href: '/guides/build-power',
              label: getPage('/guides/build-power')!.h1,
            },
            {
              href: '/quests/power-lines',
              label: getPage('/quests/power-lines')!.h1,
            },
            {
              href: '/quests/into-the-sinkhole',
              label: getPage('/quests/into-the-sinkhole')!.h1,
            },
            { href: '/trophies', label: m['control.nav.trophies']() },
          ],
        },
        {
          title: m['control.footer.site'](),
          links: [
            { href: '/about', label: m['control.about']() },
            {
              href: 'mailto:support@controlresonanttools.online',
              label: m['control.contact'](),
            },
            { href: '/privacy-policy', label: m['control.privacy']() },
            { href: '/terms-of-service', label: m['control.terms']() },
          ],
        },
      ]}
    />
  );
}
